
export const S3URL = process.env.REACT_APP_AWS_S3_FILE_URL + '/'